/**
 *  @class
 *  @function SocialShare
 */
if (!customElements.get('social-share')) {
  class SocialShare extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.links = document.querySelectorAll('.social:not(.clipboard):not(.whatsapp)');

      this.setupEventListeners();
    }

    setupEventListeners() {
         const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
      
      this.links.forEach((link) => {
        link.addEventListener('click', (event) => {
          // On mobile devices, let the browser handle the link naturally with target="_blank"
          // This prevents iOS Safari popup blocking issues
          if (isMobile) {
            // Don't prevent default - let target="_blank" work naturally
            return;
          }
          
          // On desktop, use popup window
          event.preventDefault();
          let left = (screen.width / 2) - (640 / 2),
            top = (screen.height / 2) - (440 / 2) - 100;
          window.open(link.getAttribute('href'), 'mywin', 'left=' + left + ',top=' + top + ',width=640,height=440,toolbar=0');
        });
      });
    }
  }
  customElements.define('social-share', SocialShare);
}